import { useNavigate } from 'react-router-dom';

interface WorkspacePlaceholderProps {
  title: string;
  description: string;
  capabilities: string[];
}

/**
 * Placeholder reutilizable para workspaces que aun no tienen contenido funcional.
 * Muestra titulo, descripcion, capacidades previstas y escape al editor territorial.
 */
export function WorkspacePlaceholder({
  title,
  description,
  capabilities,
}: WorkspacePlaceholderProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="ws-placeholder">
      <h2 className="ws-placeholder-title">{title}</h2>
      <p className="ws-placeholder-desc">{description}</p>
      <div className="ws-placeholder-capabilities">
        <span className="ws-placeholder-cap-label">Capacidades previstas</span>
        {capabilities.map(cap => (
          <div key={cap} className="ws-placeholder-cap-item">
            <span className="ws-placeholder-cap-dot" aria-hidden="true" />
            <span>{cap}</span>
          </div>
        ))}
      </div>
      <button
        className="ws-placeholder-action"
        onClick={() => navigate('/workspaces/territory')}
        type="button"
      >
        Ir al editor territorial →
      </button>
    </div>
  );
}
